import React, { useState } from 'react';
import { Sidebar } from '../components/navigation/Sidebar';
import { Header } from '../components/navigation/Header';
import { MobileNavbar } from '../components/navigation/MobileNavbar';
interface MainLayoutProps {
  children: React.ReactNode;
}
export function MainLayout({
  children
}: MainLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="flex h-screen bg-[#F5F6F8]" data-id="element-1545">
      {/* Sidebar - hidden on mobile */}
      <div className="hidden md:block" data-id="element-1546">
        <Sidebar data-id="element-1547" />
      </div>
      {/* Mobile sidebar - shown when menu is clicked */}
      {sidebarOpen && <div className="fixed inset-0 z-40 md:hidden" data-id="element-1548">
          <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-1549"></div>
          <div className="relative flex flex-col w-full max-w-xs pb-12 overflow-y-auto bg-white" data-id="element-1550">
            <Sidebar mobile onClose={() => setSidebarOpen(false)} data-id="element-1551" />
          </div>
        </div>}
      <div className="flex flex-col flex-1 w-0 overflow-hidden" data-id="element-1552">
        <Header onMenuClick={() => setSidebarOpen(true)} data-id="element-1553" />
        <main className="relative flex-1 overflow-y-auto focus:outline-none" data-id="element-1554">
          <div className="py-6" data-id="element-1555">
            <div className="px-4 mx-auto max-w-7xl sm:px-6 md:px-8" data-id="element-1556">
              {children}
            </div>
          </div>
        </main>
        {/* Mobile bottom navigation */}
        <div className="md:hidden" data-id="element-1557">
          <MobileNavbar data-id="element-1558" />
        </div>
      </div>
    </div>;
}